import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: calc(${props => props.theme.maxWidth} - 600px);
  margin: 0 auto;
  padding: 60px 30px;
  ${bp('sm')`
    padding: 30px 20px;
  `}

  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
  }

  a {
    color: ${props => props.theme.palette.primary.alpha};
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  h1 {
    ${props => props.theme.css.heading1}
    font-size: 32px;
    margin: 0 0 2em;
  }

  h2 {
    ${props => props.theme.css.heading2}
    font-size: 28px;
    margin: 0 0 1em;
  }

  h3 {
    ${props => props.theme.css.heading2}
    font-size: 22px;
    margin: 0 0 1em;
  }

  h4 {
    ${props => props.theme.css.heading2};
    font-size: 20px;
    margin: 0 0 1em;
  }

  li,
  p {
    font-size: 16px;
    line-height: 1.5;
    margin: 0 0 1em;
  }

  li {
    margin: 10px 0;
  }

  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;

    iframe,
    object,
    embed {
      border: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`
